import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { template } from 'utils/TemplateReplacement';
import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class NewUsersToRoomNoticeMessageItem extends Component {
  render() {
    const { message } = this.props;
    return (
      <div style={{ textAlign: 'center' }}>
        <div className="message-notice">
          {template(message.messageMeta.noticeMessageTemplate, {
            changedUsername: (
              <Link
                key={`changedUserNotice-${message.id}-${message.messageMeta.changedUserId}`}
                to={`/users/profile/${message.messageMeta.changedUserId}`}
              >
                {message.messageMeta.changedUsername}
              </Link>
            ),
            newUsers:
              message.messageMeta.newUsers.length > 0
                ? message.messageMeta.newUsers
                    .map(newUser => (
                      <Link
                        key={`newUserNotice-${newUser.id}`}
                        to={`/users/profile/${newUser.id}`}
                      >
                        {newUser.username}
                      </Link>
                    ))
                    .reduce((prev, curr) => [prev, ', ', curr])
                : undefined
          })}
        </div>
      </div>
    );
  }
}

NewUsersToRoomNoticeMessageItem.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.number.isRequired,
    messageMeta: PropTypes.shape({
      noticeMessageTemplate: PropTypes.string.isRequired,
      changedUsername: PropTypes.string.isRequired,
      newUsers: PropTypes.arrayOf(PropTypes.shape).isRequired,
      changedUserId: PropTypes.number.isRequired
    }).isRequired
  }).isRequired
};

export default NewUsersToRoomNoticeMessageItem;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/_messages/NewUsersToRoomNoticeMessageItem.js